import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { User, MapPin, Mail, Shield } from 'lucide-react';

const LocalProfilePage = () => {
  const { user } = useAuth();

  return (
    <div className="p-4 space-y-6" data-testid="local-profile-page">
      <div>
        <h2 className="text-2xl font-heading font-bold text-slate-900">Perfil</h2>
        <p className="text-sm text-muted-foreground mt-1">Información de tu cuenta</p>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 divide-y divide-slate-200">
        <div className="p-4 flex items-center gap-4">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
            <User className="w-6 h-6 text-primary" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-muted-foreground">Nombre</p>
            <p className="font-semibold text-slate-900">{user?.name}</p>
          </div>
        </div>

        <div className="p-4 flex items-center gap-4">
          <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center">
            <Mail className="w-6 h-6 text-accent" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-muted-foreground">Email</p>
            <p className="font-semibold text-slate-900">{user?.email}</p>
          </div>
        </div>

        <div className="p-4 flex items-center gap-4">
          <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center">
            <Shield className="w-6 h-6 text-slate-600" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-muted-foreground">Usuario</p>
            <p className="font-semibold text-slate-900">{user?.username}</p>
          </div>
        </div>

        <div className="p-4 flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
            <MapPin className="w-6 h-6 text-blue-600" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-muted-foreground">Rol</p>
            <p className="font-semibold text-slate-900">Usuario de Local</p>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-slate-100 to-slate-200 rounded-lg p-6 text-center">
        <p className="text-sm text-slate-600">
          Sistema de Gestión de Pedidos v1.0
        </p>
        <p className="text-xs text-slate-500 mt-2">
          © 2024 Todos los derechos reservados
        </p>
      </div>
    </div>
  );
};

export default LocalProfilePage;